<template>
  <sc-page-unlogged>
    <form-email
      v-show="isEmailCheck"
      :isEmailCheck.sync="isEmailCheck"
      :email.sync="email"
      :saveEmail.sync="saveEmail"></form-email>
    <form-login v-if="!isForgetPassword && !isTwoFactorAuth && !isEmailCheck"
      :isForgetPassword.sync="isForgetPassword"
      :isTwoFactorAuth.sync="isTwoFactorAuth"
      :saveEmail.sync="saveEmail"
      :email.sync="email"
      :isBlocked.sync="isBlocked"
      :class="{'animated flipInX': isForgetPassword !== null && !isForgetPassword}"
      @goBackToEmailCheck="isEmailCheck = true" />

    <form-forget-password v-show="isForgetPassword"
                          :email.sync="email"
                          :isBlocked.sync="isBlocked"
                          :isForgetPassword.sync="isForgetPassword"
                          :class="{'animated flipInX': isForgetPassword}" />

    <form-two-factor-auth v-show="isTwoFactorAuth"
                          :isTwoFactorAuth.sync="isTwoFactorAuth"
                          :isForgetPassword.sync="isTwoFactorAuth"
                          :saveEmail.sync="saveEmail"
                          :email.sync="email"
                          :class="{'animated flipInX': isTwoFactorAuth}" />

  </sc-page-unlogged>
</template>

<script>
  import { ScPageUnlogged } from '@intelipost-js/secure-components';
  import FormLogin from './forms/FormLogin';
  import FormEmail from './forms/FormEmail';
  import FormForgetPassword from './forms/FormForgetPassword';
  import FormTwoFactorAuth from './forms/FormTwoFactorAuth';

  export default {
    name: 'page-login',
    data() {
      return {
        email: null,
        isForgetPassword: null,
        isTwoFactorAuth: null,
        saveEmail: null,
        isEmailCheck: true,
        isBlocked: null,
      };
    },
    components: {
      ScPageUnlogged,
      FormLogin,
      FormEmail,
      FormForgetPassword,
      FormTwoFactorAuth,
    },
  };
</script>



// WEBPACK FOOTER //
// src/features/public/login/default/PageLogin.vue?78a10904